import { useMutation } from '@tanstack/react-query';
import { apiUpdateAllocations } from '../../../../api';
import { FinancialDocumentAllocation } from '../../../../../../models/IncomingInvoices';

interface UpdateAllocationsParams {
  projectId: string;
  financialDocumentId: string;
  allocations: FinancialDocumentAllocation[];
}

export function useUpdateAllocationsMutation() {
  return useMutation({
    mutationFn: async (params: UpdateAllocationsParams) => {
      return apiUpdateAllocations(
        params.projectId,
        params.financialDocumentId,
        params.allocations
      );
    },
  });
}
